import { useEffect, useRef, useState } from 'react';
import styles from './ReplayCarousel.module.scss';
import { BaseIcon } from '@spinwise/react-component-library/BaseIcon';
import { EBrandIconVariants } from '../../../../libraries/variants.library';
import { IconLibrary } from '../../../../libraries/icons.library';
import ReplayPreview from './ReplayPreview/ReplayPreview';
import axios from 'axios';
import PaginationDots from '../../../shared/Pagination/PaginationDots/PaginationDots';
import { t } from 'i18next';
import ReplayOverlay from './ReplayPreview/ReplayOverlay/ReplayOverlay';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import OverlayFixedBg from 'Components/shared/Overlay/elements/OverlayFixedBg/OverlayFixedBg';
import { getCookie } from 'cookies-next';
import ReplayPreviewSport from './ReplayPreviewSport/ReplayPreviewSport';
import useScreenBreakpoint from 'Hooks/useScreenBreakpoints';
enum ECategory {
  ALL_TIME = 'all_time',
  CURRENT = 'current',
  THIS_YEAR = 'this_year',
  SPORT = 'sport',
}
interface IStrapiCasinoResponse {
  data: {
    wins: Array<{
      brands;
      category;
      country_flag;
      game_name;
      id;
      image;
      provider;
      replay_url;
      thumbnail_image;
      user_name;
      win_amount;
    }>;
  };
}
interface IStrapiSportResponse {
  data: {
    data: {
      attributes: {
        latest_sport_wins: Array<{
          id: number;
          category: string;
          time: string;
          date: string;
          user_name: string;
          win_amount: string;
          bet_amount: string;
          team_name: string;
          coefficient: number;
          bet_title: string;
          sport_name: string;
          image: {
            data: null;
          };
          team_logo: {
            data: null;
          };
        }>;
      };
    };
  };
}
const TABLET_WIDTH = 1279;

interface IReplayCarousel {
  locale;
  player_type?: string;
}
const ReplayCarousel = ({ locale, player_type = 'casino' }: IReplayCarousel) => {
  const [currentPositionScroll, setCurrentPositionScroll] = useState(0);

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const isMobile = useScreenBreakpoint(TABLET_WIDTH);

  const [selectedCategory, setSelectedCategory] = useState(
    player_type != 'casino' ? ECategory.SPORT : ECategory.CURRENT,
  );

  const [currentWinsArr, setCurrentWinsArr] = useState([]);
  const [allTimeArr, setAllTimeArr] = useState([]);
  const [thisYearArr, setThisYearArr] = useState([]);
  const [sportCategory, setSportCategory] = useState([]);

  useEffect(() => {
    setCurrentPositionScroll(0);
  }, [isMobile]);

  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (isMobile == false) return;
    if (touchStart - touchEnd > 75) {
      // do your stuff here for left swipe
      if (currentPositionScroll < data?.length - 1) moveCard(currentPositionScroll + 1);
    }

    if (touchStart - touchEnd < -75) {
      // do your stuff here for right swipe
      if (currentPositionScroll > 0) moveCard(currentPositionScroll - 1);
    }
  };
  const sliderRef = useRef<HTMLDivElement>();
  const [data, setData] = useState<Array<any>>(undefined);

  useEffect(() => {
    if (!data) getData(selectedCategory);
  }, []);

  const getData = async (category: ECategory) => {
    if (category == ECategory.CURRENT && currentWinsArr.length != 0) {
      setData(currentWinsArr);
      return;
    }
    if (category == ECategory.ALL_TIME && allTimeArr.length != 0) {
      setData(allTimeArr);
      return;
    }
    if (category == ECategory.THIS_YEAR && thisYearArr.length != 0) {
      setData(thisYearArr);
      return;
    }
    if (category == ECategory.SPORT && sportCategory?.length != 0) {
      setData(sportCategory);
      return;
    }

    const geo = getCookie('country');
    let response: Array<any>;
    if (player_type != 'casino' && category == ECategory.SPORT) {
      const r: IStrapiSportResponse = await axios.get(`/api/content/latest-wins-sport?populate=deep&locale=${locale}`);
      response = r?.data?.data?.attributes?.latest_sport_wins;
    } else {
      const r: IStrapiCasinoResponse = await axios.get(
        `/api/content/wins?populate=deep&locale=${locale}&category=${category}&brand=winnerz&geo=${geo}`,
      );
      response = r.data.wins;
    }
    switch (category) {
      case ECategory.CURRENT:
        setCurrentWinsArr(response);
        break;
      case ECategory.ALL_TIME:
        setAllTimeArr(response);
        break;
      case ECategory.THIS_YEAR:
        setThisYearArr(response);
        break;
      case ECategory.SPORT:
        setSportCategory(response);
    }
    setData(response);
  };

  const onClickArrowButton = (isLeft: boolean) => {
    const allCategories: Array<any> =
      player_type != 'casino'
        ? [ECategory.SPORT, ECategory.ALL_TIME]
        : [ECategory.ALL_TIME, ECategory.CURRENT, ECategory.THIS_YEAR];
    const currentIndex = allCategories.indexOf(selectedCategory);
    let nextIndex = 0;
    if (isLeft == true) {
      if (currentIndex - 1 >= 0) {
        //ok
        nextIndex = currentIndex - 1;
      } else {
        //get last
        nextIndex = allCategories.length - 1;
      }
    } else {
      if (currentIndex + 1 <= allCategories.length - 1) {
        //ok
        nextIndex = currentIndex + 1;
      }
    }
    getData(allCategories[nextIndex]);
    setSelectedCategory(allCategories[nextIndex]);
    setCurrentPositionScroll(0);
  };
  useEffect(() => {
    if (!sliderRef?.current) return;
  }, [sliderRef.current]);

  const moveCard = index => {
    if (index >= 0 && index <= data?.length) setCurrentPositionScroll(index);
  };

  const getCarouselBlocks = (elements, category: ECategory = ECategory.ALL_TIME) => {
    if (!elements) return <></>;
    return (
      <>
        {elements.map(el => {
          if (player_type != 'casino' && category == ECategory.SPORT) {
            return (
              <div key={el.id} className={`${styles.middle_item} d-fl ai-c jc-c`}>
                <ReplayPreviewSport {...el} />
              </div>
            );
          }
          return (
            <div key={el.id} className={`${styles.middle_item} d-fl ai-c jc-c`}>
              <ReplayPreview
                isMobile={isMobile}
                amount={el?.win_amount}
                gameName={el?.game_name}
                title={el?.user_name}
                bgImage={el?.image?.url}
                link={el?.replay_url}
                country_flag={el?.country_flag}
                onClickReplay={() => {
                  setShowReplayModal({
                    show: true,
                    content: {
                      link: el?.replay_url,
                      icon: el?.thumbnail_image,
                      name: el?.game_name,
                      provider: el?.provider,
                    },
                  });
                }}
              ></ReplayPreview>
            </div>
          );
        })}
      </>
    );
  };
  const getNavButton = (category: ECategory, text: string) => {
    return (
      <>
        <div
          className={`${selectedCategory == category ? styles.nav_button_selected : styles.nav_button} ${
            styles.no_hightlight
          }`}
          onClick={() => {
            if (selectedCategory != category) {
              setSelectedCategory(category);
              switch (category) {
                case ECategory.ALL_TIME:
                  if (allTimeArr.length == 0) {
                    return getData(category);
                  }

                  setData(allTimeArr);
                  break;
                case ECategory.CURRENT:
                  if (currentWinsArr.length == 0) {
                    return getData(category);
                  }
                  setData(currentWinsArr);
                  break;
                case ECategory.THIS_YEAR:
                  if (thisYearArr.length == 0) {
                    return getData(category);
                  }
                  setData(thisYearArr);
                  break;
                case ECategory.SPORT:
                  if (sportCategory.length == 0) {
                    return getData(category);
                  }
                  setData(sportCategory);
                  break;
              }
              setCurrentPositionScroll(0);
            }
          }}
        >
          {text}
        </div>
      </>
    );
  };
  const getStepPrecentage = () => {
    if (isMobile == true) {
      return `calc(-90vw * ${currentPositionScroll} - 16px * ${currentPositionScroll})`;
    } else {
      return `${currentPositionScroll * -33.333}%`;
    }
  };
  const [showReplayModal, setShowReplayModal] = useState({
    show: false,
    content: null,
  });

  return (
    <>
      {data && (
        <div className={`${styles.replayCarousel_container}`}>
          <div className={`${styles.nav_panel}`}>
            <div className={`${styles.nav_panel_inner} d-fl ai-c jc-c`}>
              <div
                className={`${styles.nav_circle} ${styles.nav_circle_left} d-fl ai-c jc-c`}
                onClick={() => {
                  onClickArrowButton(true);
                }}
              >
                <BaseIcon
                  isActive={false}
                  isMasked={true}
                  isStatic={true}
                  iconName={IconLibrary.ArrowRight}
                  variant={EBrandIconVariants.Black}
                ></BaseIcon>
              </div>
              {player_type != 'casino' ? (
                <>
                  {getNavButton(ECategory.SPORT, t('homepage.sport.replay.sport.wins'))}
                  {getNavButton(ECategory.ALL_TIME, t('homepage.sport.replay.all.wins'))}
                </>
              ) : (
                <>
                  {getNavButton(ECategory.ALL_TIME, t('homepage.b.replay.all.time.wins'))}
                  {getNavButton(ECategory.CURRENT, t('homepage.b.replay.current.wins'))}
                  {getNavButton(ECategory.THIS_YEAR, t('homepage.b.replay.best.this.year.wins'))}
                </>
              )}
              <div
                className={`${styles.nav_circle}  d-fl ai-c jc-c`}
                onClick={() => {
                  onClickArrowButton(false);
                }}
              >
                <BaseIcon
                  isActive={false}
                  isMasked={true}
                  isStatic={true}
                  iconName={IconLibrary.ArrowRight}
                  variant={EBrandIconVariants.Black}
                ></BaseIcon>
              </div>{' '}
            </div>
          </div>
          <div className={`${styles.replay_container}`}>
            {currentPositionScroll > 0 && (
              <div
                className={`${styles.arrow_container} ${styles.revers} d-fl ai-c jc-c ${styles.no_hightlight}`}
                onClick={() => {
                  moveCard(currentPositionScroll - 1);
                }}
              >
                <BaseIcon
                  isActive={false}
                  isMasked={true}
                  isStatic={true}
                  iconName={IconLibrary.ArrowRight}
                  variant={EBrandIconVariants.Black}
                ></BaseIcon>
              </div>
            )}
            {currentPositionScroll == 0 && <div className={`${styles.hidden_nav_button}`}></div>}
            <div
              className={`${styles.middle_container}`}
              // style={{ paddingLeft: `${isMobile == true ? '15%' : '0'}` }}
            >
              <div
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                className={`${styles.scroll_panel} d-fl`}
                ref={sliderRef}
                key={selectedCategory}
                style={{
                  transform: `translateX(${currentPositionScroll == 0 ? '0%' : getStepPrecentage()})`,
                }}
              >
                {selectedCategory == ECategory.ALL_TIME && getCarouselBlocks(allTimeArr)}
                {selectedCategory == ECategory.CURRENT && getCarouselBlocks(currentWinsArr)}
                {selectedCategory == ECategory.THIS_YEAR && getCarouselBlocks(thisYearArr)}
                {selectedCategory == ECategory.SPORT && getCarouselBlocks(sportCategory, ECategory.SPORT)}
              </div>
            </div>
            {currentPositionScroll != data?.length - 3 && (
              <div
                className={`${styles.arrow_container} ${styles.no_hightlight}  d-fl ai-c jc-c`}
                onClick={() => {
                  moveCard(currentPositionScroll + 1);
                }}
              >
                <BaseIcon
                  isActive={false}
                  isMasked={true}
                  isStatic={true}
                  iconName={IconLibrary.ArrowRight}
                  variant={EBrandIconVariants.Black}
                ></BaseIcon>
              </div>
            )}
          </div>
          <div className={`${styles.nav_bottom_panel}`} key={selectedCategory}>
            <PaginationDots
              key={selectedCategory}
              pageCount={data?.length}
              onSelectEvent={index => {
                moveCard(index);
              }}
              selectedId={currentPositionScroll}
            ></PaginationDots>
          </div>
        </div>
      )}
      {showReplayModal?.show == true && (
        <OverlayFixedBg
          closeBg={() => {
            setShowReplayModal({ show: false, content: null });
          }}
          position={POSITIONS.CENTER}
          contentWidth={EOverlayContentWidth.REPLAY}
        >
          <ReplayOverlay
            content={showReplayModal.content}
            onClickClose={() => {
              setShowReplayModal({ show: false, content: null });
            }}
          ></ReplayOverlay>
        </OverlayFixedBg>
      )}
    </>
  );
};
export default ReplayCarousel;
